import React from 'react';
import { useSelector } from 'react-redux';

import { Box, Divider, Skeleton, Stack, Typography } from '@mui/material';
import PendingChangeWrapper from '@sharedCR/common/PendingChangeWrapper';
import RoundedBox from '@sharedCR/common/RoundedBox';
import { DateIcon } from '@sharedCR/coreDesignSystem/icons';
import useLoanPendingChangeAuthors from 'app/pages/loanApplication/hooks/useLoanPendingChangeAuthors';
import { WithLoadingPropTypes } from 'hocs/withLoading';

import { PendingChangesActionType } from 'constants/pendingChanges';
import useLoanId from 'hooks/useLoanId';
import { getFieldPendingChangeAuthors } from 'utils/pendingChangesAuthors';

import { selectEntityChangedPropsById, selectPostClosing } from 'store/loanApplications/selectors';

import { getKeyDatesConfig } from './KeyDates.config';
import { dividerStyles, itemLabelStyles, itemRowStyles } from './KeyDates.styles';

const KeyDates = ({ isLoading }) => {
  const loanId = useLoanId();
  const postClosing = useSelector(selectPostClosing);
  const pendingChangesData = useSelector(selectEntityChangedPropsById(loanId));
  const fieldAuthors = useLoanPendingChangeAuthors();

  const keyDatesConfig = getKeyDatesConfig({ postClosing, pendingChangesData });

  return (
    <RoundedBox>
      {keyDatesConfig.map((item, index) => (
        <Box key={item.id}>
          {isLoading ? (
            <Skeleton height={24} variant="text" width="100%" />
          ) : (
            <Stack direction="row" sx={itemRowStyles}>
              <Stack direction="row" sx={itemLabelStyles}>
                <DateIcon />
                <Typography color="text.dark" variant="regular14">
                  {item.name}:
                </Typography>
              </Stack>
              <PendingChangeWrapper
                isSmall
                authors={getFieldPendingChangeAuthors(fieldAuthors, item.id)}
                fieldLabel={item.name}
                pendingChangesActionType={
                  item.isModified ? PendingChangesActionType.MODIFIED : null
                }
                textSelector="span"
              >
                <Typography variant="bold16">{item.value}</Typography>
              </PendingChangeWrapper>
            </Stack>
          )}
          {index !== keyDatesConfig.length - 1 && <Divider sx={dividerStyles} />}
        </Box>
      ))}
    </RoundedBox>
  );
};

KeyDates.propTypes = {
  ...WithLoadingPropTypes,
};

export default KeyDates;
